import newCv from "@/auto-generated/cv.json";
export function useApiConfig() {
  const sbApi = "https://api.storyblok.com/v2/cdn/stories";
  const cv = "?cv=" + newCv;
  const token = "&token=" + import.meta.env.VITE_STORYBLOK_TOKEN;
  const version = "&version=" + import.meta.env.VITE_STORYBLOK_VERSION;
  const ApiLink = `${sbApi}${cv}${token}${version}`;
  return {
    sbApi,
    cv,
    token,
    version,
    ApiLink,
  };
}
